import React, { useCallback } from 'react';

import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';

import { SF_SUPPORT_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Security/securityActions';
import SwitchField from '../Controls/SwitchField/SwitchField';
import useFeature from '../../hooks/featureFlags/useFeature';

const { SF_SUPPORT_ENABLED, SEND_DIAGNOSTICS, SEND_DIAGNOSTICS_ANON } = SF_SUPPORT_FIELDS;

const SFSupport = ({ fields, dispatch }) => {
    const enableSFSupport = fields[SF_SUPPORT_ENABLED.ID];
    const sendDiagnostics = fields[SEND_DIAGNOSTICS.ID];
    const sendDiagnosticsAnon = fields[SEND_DIAGNOSTICS_ANON.ID];

    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const notSupport = systemMode !== SYSTEM_MODES.SAAS_SUPPORT;

    const dispatchUpdate = useCallback(
        (action, fieldId, value) => {
            dispatch({
                type: action,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {enableSFSupport && notSupport && (
                <SwitchField
                    field={enableSFSupport}
                    changed={(fieldId, val) => dispatchUpdate(actions.ENABLE_SF_SUPPORT, fieldId, val)}
                />
            )}
            {sendDiagnostics && sendDiagnosticsAnon && (
                <SwitchField
                    field={sendDiagnostics}
                    marginTop="large"
                    changed={(fieldId, val) => dispatchUpdate(actions.SHARE_DIAG, fieldId, val)}>
                    <SwitchField
                        field={sendDiagnosticsAnon}
                        marginTop="none"
                        changed={(fieldId, val) => dispatchUpdate(actions.SHARE_DIAG_ANON, fieldId, val)}
                    />
                </SwitchField>
            )}
        </>
    );
};

export default React.memo(SFSupport);
